// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ExpertIn } from './expertIn.zod.ts';

export const assetUpdateInCountriesOneItemMax = 10;

export const assetUpdateInCountriesOneMax = 300;

export const assetUpdateInExpertsOneMax = 50;

export const assetUpdateInHomeCountryOneMax = 6;

export const assetUpdateInIndustryIdsOneMax = 50;

export const assetUpdateInNameOneMax = 120;

export const assetUpdateInPartnersOneItemMax = 120;

export const assetUpdateInPartnersOneMax = 50;

export const assetUpdateInSummaryOneMax = 600;

export const assetUpdateInTaglineOneMax = 200;

export const AssetUpdateIn = zod.object({
  "countries": zod.union([zod.array(zod.string().max(assetUpdateInCountriesOneItemMax)).max(assetUpdateInCountriesOneMax),zod.null()]).optional(),
  "experts": zod.union([zod.array(ExpertIn).max(assetUpdateInExpertsOneMax),zod.null()]).optional(),
  "home_country": zod.union([zod.string().max(assetUpdateInHomeCountryOneMax),zod.null()]).optional(),
  "industry_ids": zod.union([zod.array(zod.uuid()).max(assetUpdateInIndustryIdsOneMax),zod.null()]).optional(),
  "kind": zod.union([zod.enum(['platform', 'accelerator', 'framework', 'offer']),zod.null()]).optional(),
  "maturity": zod.union([zod.enum(['concept', 'pilot', 'available']),zod.null()]).optional(),
  "name": zod.union([zod.string().min(1).max(assetUpdateInNameOneMax),zod.null()]).optional(),
  "partners": zod.union([zod.array(zod.string().max(assetUpdateInPartnersOneItemMax)).max(assetUpdateInPartnersOneMax),zod.null()]).optional(),
  "revision": zod.int().min(1),
  "summary": zod.union([zod.string().max(assetUpdateInSummaryOneMax),zod.null()]).optional(),
  "tagline": zod.union([zod.string().max(assetUpdateInTaglineOneMax),zod.null()]).optional()
});

export type AssetUpdateIn = zod.input<typeof AssetUpdateIn>;
export type AssetUpdateInOutput = zod.output<typeof AssetUpdateIn>;
